import React from "react";
import Navbar from "../components/site/Navbar";
import Hero from "../components/site/Hero";
import HubBento from "../components/site/HubBento";
import About from "../components/site/About";
import Leadership from "../components/site/Leadership";
import PrayerForm from "../components/site/PrayerForm";
import UpdatesForm from "../components/site/UpdatesForm";
import Recordings from "../components/site/Recordings";
import FireHubs from "../components/site/FireHubs";
import Mentorship from "../components/site/Mentorship";
import Give from "../components/site/Give";
import Events from "../components/site/Events";
import FAQ from "../components/site/FAQ";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import MobileStickyCTA from "../components/site/MobileStickyCTA";
import PushOptIn from "../components/site/PushOptIn";
import SocialFollow from "../components/SocialFollow";
import SEO, { ORG_SCHEMA, WEBSITE_SCHEMA } from "../components/SEO";

const HOME_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Revival Fire Ministries Global | Prayer, Deliverance, Healing & Prophetic Ministry",
  "description": "Revival Fire Ministries Global is a prophetic and apostolic holiness revival ministry offering prayer, deliverance, healing, biblical teaching, prophetic mentorship, marriage prayer, family covering, and revival gatherings.",
  "url": "https://revivalfireministries.com/",
  "isPartOf": { "@type": "WebSite", "name": "Revival Fire Ministries Global", "url": "https://revivalfireministries.com" },
};

const LandingPage = () => (
  <>
    <SEO
      title="Revival Fire Ministries Global | Prayer, Deliverance, Healing & Prophetic Ministry"
      description="Revival Fire Ministries Global is a prophetic and apostolic holiness revival ministry offering prayer, deliverance, healing, biblical teaching, prophetic mentorship, marriage prayer, family covering, and revival gatherings."
      path="/"
      jsonLd={[ORG_SCHEMA, WEBSITE_SCHEMA, HOME_SCHEMA]}
    />
    <main className="relative" data-testid="landing-page">
      <Navbar />
      <Hero />
      <HubBento />
      <About />
      <Leadership />
      <PrayerForm />
      <UpdatesForm />
      <Recordings />
      <FireHubs />
      <Mentorship />
      <Give />
      <Events />
      <PushOptIn />
      <SocialFollow />
      <FAQ />
      <Contact />
      <Footer />
      <MobileStickyCTA />
    </main>
  </>
);

export default LandingPage;
